import React from 'react';

import { Helmet } from "react-helmet-async";


const title = "Return & Cancellation Policy | Shivam Shipping & Logistics";
const description =
  "Read Shivam Shipping & Logistics's Return and Cancellation Policy regarding our maritime logistics and supply chain services.";
const keywords =
  "return policy, cancellation policy, Shivam Shipping & Logistics, service refunds, logistics services, maritime policy";

const ogImage = " ";
const canonical = "https://shivamshippingandlogistics-scm.com/Legal/return-policy";


const ReturnPolicy = () => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Shivam Shipping & Logistics" />
        <meta name="language" content="en" />
        <meta name="distribution" content="global" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        {/* Canonical Link */}
        <link rel="canonical" href={canonical} />
      </Helmet>

      <div className='disclaimer px-5 mt-6 text-black mx-4'>
        <h1 className='text-center text-2xl py-10 font-bold'> Cancellation & Refund Policy </h1>
        Last updated: 2024-01-01<br /><br />
        <div className='text-lg font-medium '>Shivam Shipping & Logistics believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:</div><br />

        <li className="py-2">Cancellations for logistics services will be considered only if the request is made before the commencement of the service or vessel nomination. However, the cancellation request may not be entertained if the operational processes or port formalities have already been initiated.</li>

        <li className="py-2">Shivam Shipping & Logistics does not accept cancellation requests for services that have already been executed or where custom duties and port charges have been paid on behalf of the client.</li>

        <li className="py-2">In case of any discrepancy in service delivery or documentation, please report the same to our operations team immediately. The request will be investigated and addressed based on the terms of the specific service contract.</li>

        <li className="py-2">In case of any Refunds approved by Shivam Shipping & Logistics, it will take 7-10 working days for the refund to be processed via the original payment method or bank transfer.</li>

      </div>
    </>
  )
}

export default ReturnPolicy;
